import { Stack } from '@mui/material'
import { InfoOutlined } from '@mui/icons-material'

import { toAmountString } from '../../utils'
import { Box, Text, Tooltip } from '../../components'

// Shared by every bordered box on the Investment Account tab and its
// per-portfolio drill-down (this total balance card, each portfolio card,
// and the unlinked-activity card) -- a plain border rather than a nested
// CardBox so none of them stack a second shadow/white panel on top of the
// page's own, matching the ticket's mockup (bordered boxes all sitting on
// one panel).
export const borderedBoxSx = { border: '2px solid', borderColor: 'divider', borderRadius: 2 }

// Shown above the portfolio list on the Investment Account tab
// (investment-account.jsx), and again above the activity table on the
// single-portfolio drill-down (investment-portfolio-activity.jsx) -- the
// FLIGHT-296 mockup shows this same total balance card in both places, not
// just the multi-account list.
//
// `actions` (the drill-down's "Export Activity" button) renders in this same
// card, top-right -- optional since the multi-account list has no single
// table to export and passes nothing.
export function TotalBalanceCard({ amount, actions }) {
  return (
    <Box
      sx={{ ...borderedBoxSx, padding: 3, display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}
    >
      <Box>
        <Stack direction="row" spacing={0.5} alignItems="center" sx={{ width: 'auto' }}>
          {/* fontSize matches the "GIVING WALLET"/"INVESTMENT ACCOUNT"/
              "RECURRING" tab labels above (NavTabs) -- those render at
              theme.typography.button's 0.875rem, a size up from Caption's own
              0.75rem default. */}
          <Text.Caption color="text.secondary" sx={{ fontSize: '0.875rem' }}>
            Total Investment Account Balance
          </Text.Caption>
          <Tooltip title="The combined balance across all of your Investment Accounts." arrow>
            <InfoOutlined fontSize="small" sx={{ color: 'text.secondary' }} />
          </Tooltip>
        </Stack>
        {/* H1, not H3 -- the largest step in the theme's heading scale (2rem
            vs H3's 1.75rem), to make the total stand out more per the
            mockup's bold, prominent balance figure. */}
        <Text.H1 sx={{ mt: 1.5 }}>{toAmountString(amount)}</Text.H1>
      </Box>
      {actions}
    </Box>
  )
}
